export default __webpack_public_path__ + "static/media/icon_star_yellow.681405cd.svg";